import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { doLogout } from "helpers/logout";
import { useTranslation } from "translation/useTranslation";
import { isUserCookie } from "helpers/cookie";
import { Button } from "components/ui";

export default function NotFound() {
  const dispatch = useDispatch();
  const { editableTranslate } = useTranslation();
  const isLoggedIn = isUserCookie();

  const handleLogout = useCallback(() => {
    doLogout(dispatch, "User landed on missing page");
  }, [dispatch]);

  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light" data-testid="not-found">
      <div className="text-center bg-white shadow p-4 p-md-5 rounded-3" style={{ maxWidth: 480 }}>
        <div className="display-4 fw-bold text-primary mb-2">404</div>
        <h2 className="mb-3">{editableTranslate("error_page.not_found.title", "Die angeforderte Seite existiert nicht.")}</h2>
        <p className="text-muted mb-2">
          {editableTranslate("error_page.not_found.description", "Es scheint, dass die Seite nicht vorhanden oder der Link nicht mehr gültig ist.")}
        </p>
        <p className="text-muted mb-4">
          {isLoggedIn
            ? editableTranslate("error_page.not_found.next_steps_signed_in", "Sie können zurückgehen, sich abmelden oder uns über das Problem informieren.")
            : editableTranslate("error_page.not_found.next_steps_signed_out", "Sie können zum Anmeldebildschirm zurückkehren oder uns über das Problem informieren.")}
        </p>

        {isLoggedIn && (
          <div className="d-flex flex-column flex-md-row gap-2 justify-content-center">
            <Button data-testid="home-button" as={Link} variant="primary" to="/">
              {editableTranslate("error_page.not_found.go_home", "Zur Startseite")}
            </Button>
            <Button variant="secondary" onClick={handleLogout} data-testid="logout-button">
              {editableTranslate("error_page.not_found.logout", "Abmelden")}
            </Button>
          </div>
        )}
        <div className="mt-4">
          <div className="alert alert-danger mb-0" role="alert" data-testid="not-found-message">
            {editableTranslate("error_page.not_found.report_issue_description", "Wenn Sie glauben, dass dies ein Fehler ist, können Sie über das Feedback-Formular auf der rechten Seite des Bildschirms eine Meldung senden.")}
          </div>
        </div>
      </div>
    </div>
  );
}
